var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 4,
    viewBox: "0 0 8 4",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05469 1.07422L4.57422 3.57422C4.4375 3.69141 4.28125 3.75 4.125 3.75C3.94922 3.75 3.79297 3.69141 3.67578 3.57422L1.19531 1.07422C1 0.898438 0.941406 0.625 1.03906 0.390625C1.13672 0.15625 1.37109 0 1.625 0H6.60547C6.85938 0 7.07422 0.15625 7.17188 0.390625C7.26953 0.625 7.23047 0.898438 7.05469 1.07422Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.1439159ac0868a9069144168ce605211.svg";
export { ForwardRef as ReactComponent };